exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-column-75 {\n  float: left;\n  width: 70%;\n}\n\n.container-column-25 {\n  float: right;\n  width: 28%;\n}\n\n.float-right {\n  float: right;\n}\n", ""]);

// exports
